<template>
  <div class="outreach_content clearfix"
       @click="handleDetail"
       @contextmenu.stop.prevent="">
    <!--内容区域 开始-->
    <div class="video-info-box">
      <!--视频区域 开始-->
      <div class="video-box fl"
           v-if="introData.pictures"
           @contextmenu="tabRight($event)"
           @touchstart="touchstarts($event)"
           @touchmove="touchmoves()"
           @touchend="touchends()">
        <Video v-if="isVideo(introData.pictures[0])" :src="changeUrl(introData.pictures[0])" :title="introData.others[0].standardData" width="100%" height="100%"></Video>
        <div v-else-if="!introData.pictures[0]"
             class="img">
        </div>
        <img v-else
             :src="changeUrl(introData.pictures[0])"
             alt=""
             style="width:100%;height:100%;"
             srcset="">
      </div>
      <!--视频区域 结束-->
      <!--视频介绍 开始-->
      <div class="video-intro fl"
           @contextmenu="tabRight($event)"
           @touchstart="touchstarts($event)"
           @touchmove="touchmoves()"
           @touchend="touchends()">
        <div v-for="(tag,ind) in introData.others"
             v-show="ind < 2"
             :key="ind"
             :style="ind==1?textStyleObject:''"
             :class="[ind==0?'tit':ind==1&&blueContent.length?'text':'origintext']">
            <label v-show="ind==1&&Intro&&blueContent.length&&linesHeight>90" class="btn" @click.stop="gotoIntro">更多∨</label>
            <span v-html="tag.standardData.replace(/\n/g, '</br>')" :ref="'s'+ind"></span>
            <span v-show="ind==1&&!Intro&&blueContent.length" class="btns" @click.stop="retract">收起∧</span>
        </div>
        <moreStorage :blueContent="blueContent" @openIframe="openIframe" v-show="blueContent.length"></moreStorage>
      </div>
      <!--视频介绍 结束-->

    </div>
    <!--内容区域 结束-->
  </div>
</template>
<script>
import Bus from '../../bus.js';
import tit from "./control/tit.vue"
import Video from "../videos.vue"
import moreStorage from "../../components/flowDetail/moreStorage.vue";
export default {
  name: "qyjjContent",
  components: {
    tit,
    Video,
    moreStorage
  },
  props: {
    blockData: {
      type: Object
    }
  },
  data () {
    return {
      sign: '2',
      timeOutEvent: 0,
      leftTabInd: 0,
      topTabInd: 0,
      contendId: '',
      floorDetailShow: '',
      introData: {
        pictures: [],
        others: null
      },
      nodeId: '',
      blockId: '',
      flowId: '',
      lineClamp:3,
      Intro:true,
      blueContent:[],
      contentWzUrl:''
    }
  },
  mounted () {
    this.flowId = this.blockData;
    this.getBlockByFlowId(this.blockData.id);
    this.$http
      .get("/zciid-deliverable/showPlatformStyle/flow/api/getShowFlowPosition.json", {
        appId: this.getQuery('appId'),
        flowId: this.blockData.id,
        flowOrDetail: 'detail',
        domainNameType: document.location.pathname.split('/')[1]
      }).then(res => {
        this.floorDetailShow = res.data ? res.data : 'down'
      })

  },
  computed: {
    tagData () {
      return this.$store.state.tagData;
    },
    textStyleObject () {
      return {
        'max-height': 30 * this.lineClamp + 'px'
      }
    },
    linesHeight(){
      return this.$refs.s1[0].offsetHeight
    }
  },
  methods: {
    openIframe(url,name){
      layer.open({
        type: 2,
        title: name,
        fixed: true,
        maxmin: true,
        area: ['100%', '100%'],
        content: url,
        close: function () {
        }
      });
    },
    //更多
    gotoIntro(){
      this.lineClamp = 1000;
      this.Intro = false;
    },
    retract(){
      this.lineClamp = 3;
      this.Intro = true;
    },
    touchstarts (ev) {
      var _this = this;
      // 长按事件触发
      clearTimeout(_this.timeOutEvent);
      _this.timeOutEvent = setTimeout(function () {
        _this.timeOutEvent = 0;
        _this.tabRight(ev);
      }, 400);
      //长按400毫秒
      // e.preventDefault();
    },
    touchmoves () {
      clearTimeout(this.timeOutEvent);
      this.timeOutEvent = 0;
    },
    touchends (e) {
      clearTimeout(this.timeOutEvent);
      return false;
    },
    tabRight (ev) {
      this.$store.commit('setFlowType', this.blockData.floorType);
      window.$floorflowId = '';
      window.$nodeId = '';
      if (this.sign) {
        window.$dataType = this.sign;
      }
      if (this.nodeId) {
        window.$nodeId = this.nodeId;
      }
      if (this.flowId) {
        window.$floorflowId = this.flowId;
      }
      if (this.contentId) {
        if (!window.$rightLeft) {
          window.$rightLeft = {}
        }
        window.$rightLeft.center = {
          contentId: this.contentId,
          //     contentShowRowsSort:'0'
        }
      }
      Bus.$emit('windowRight', ev, 'block','platform-show');
    },
    //筛选文字信息
    getTagsTypeToday (list) {
      var alist = [];
      list.map((ite, index) => {
        var empty = true;
        for (var i = 0; i < ite.length; i++) {
          if (ite[i].standardData && ite[i].standardData.indexOf('http') == -1) {
            alist.push({
              name: ite[i].standardData,
              time: ''
            })
            empty = false;
            ite.splice(i, 1);
            break;
          }
        }
        if (empty) {
          alist.push({
            name: '',
            time: ''
          })
        }
        for (var j = 0; j < ite.length; j++) {
          if (ite[j].standardData && ite[j].standardData.indexOf('http') == -1) {
            alist[index].time = ite[j].standardData;
            break;
          }
        }
      })
      for (var i = 0; i < alist.length; i++) {
        if (alist[i].name == '' && alist[i].time == '') {
          alist.splice(i, 1);
        }
      }
      return alist;
    },
    getProduct (pDataArr) {
      var pictures = [];
      var others = [];
      var arr = [];
      var pcVideo='',mobileVideo='';
      if (pDataArr && pDataArr.length > 0) {
        this.contentId = pDataArr[0].contentId;
        this.sign = pDataArr[0].sign ? pDataArr[0].sign : '2';
        this.contentWzUrl = pDataArr[0].contentWzUrl;
        let intro = pDataArr[0].standardJson;
        for (var i = 0; i < pDataArr.length; i++) {
          arr.push(pDataArr[i].standardJson);
          for (var j = 0; j < pDataArr[i].standardJson.length; j++) {
            if (pDataArr[i].standardJson) {
              if ((pDataArr[i].standardJson[j].standardData.indexOf('.png') > 0 || pDataArr[i].standardJson[j].standardData.indexOf('.jpg') > 0) || pDataArr[i].standardJson[j].standardData.indexOf('.mp4') > 0 || pDataArr[i].standardJson[j].standardData.indexOf('.jpeg') > 0) {
                if(pDataArr[i].standardJson[j].standardEnName == 'videoShow'){
                  pcVideo = pDataArr[i].standardJson[j].standardData;
                }
                if(pDataArr[i].standardJson[j].standardEnName == 'subVideo1'){
                  mobileVideo = pDataArr[i].standardJson[j].standardData;
                }
                if(pcVideo&&mobileVideo){
                  break;
                }
              }
            }
          }
        }
        //筛选多条数据中有两条文字信息的数据
        var data = this.getTagsTypeToday(arr);
        data.forEach(element => {
          if (element.name && element.time) {
            others.push({ standardData: element.name }, { standardData: element.time });
            return;
          }
        });
      }
      if(this.IsMobile()){
        if(mobileVideo){
          pictures.push(mobileVideo);
        }else{
          pictures.push(pcVideo);
        }
      }else{
        pictures.push(pcVideo);
      }
      if (pictures.length == 0) {
        pictures = []
      }
      this.introData.pictures = pictures;
      this.introData.others = others;
      //针对ie浏览器做的多行文本省略号
      // if (!!window.ActiveXObject || "ActiveXObject" in window) {
      //   setTimeout(() => {
      //     $('.video-intro .text').each(function (i, obj) {
      //       var lineHeight = parseInt($(this).css("line-height"));    // 当前文本行高
      //       var height = parseInt($(this).height());    // div容器高度
      //       if ((height / lineHeight) > 8) {    // 此处 8 为限制行数
      //         $(this).addClass("text_after")    // 超过两行添加省略号
      //         $(this).css("height", "240px");    // 此处 240px 对应上面的 8 行（因为css中设置的行高是30px，js中限制的行数为 8 行，所以超出两行后高度固定为240px）
      //       } else {
      //         $(this).removeClass("text_after");    // 不足两行删除省略号
      //       }
      //     });
      //   }, 1)
      // }


    },
    getBlockByFlowId (id) {
      this.$http
        .get("/zciid-deliverable/showPlatformStyle/flow/api/get/getBlockDataListByFlowPid.json", {
          //   appId:this.blockData.appId,
          appId: this.getQuery('appId'),
          flowId: id
        })
        .then(res => {
          if (res.state == 1) {
            this.nodeId = res.data.nodeId;
            var Blockitem = res.data[0];
            return Blockitem;
          } else {
            this.getProduct([]);
          }

        }).then(Blockitem => {
          if (Blockitem) {
            this.getTagsByBlockId(Blockitem);
          }
        });
    },
    getTagsByBlockId (item) {
      this.blockId = item.id;
      window.$blockId = item.id;
      this.nodeId = item.nodeId;
      this.$http
        .get("/zciid-deliverable/showPlatformStyle/flow/api/get/getContentDataByBlockNodeId.json", {
          appId: this.getQuery('appId'),
          sceneId: item.sceneId,
          blockId: item.id,
          nodeId: item.nodeId,
          sceneGroupId: item.sceneGroupId,
          bannerQyjj:'1'
        }).then(res => {
          if (res.state == 1) {
            this.getProduct(res.data);
          }
          return res;
        }).then(res => {
          this.$http
            .get("/zciid-deliverable/api/webapp/app/relation/flowPath.json", {
              wzAppId:this.getQuery('appId'),contentId:res.data ? res.data[0].contentId : '',floorEnName:this.blockData.flowEnName
            }).then(req => {
              if(req.state == 1 && req.data.length){
                req.data.forEach((ele,ind)=>{
                  ele.show = true;
                })
                this.blueContent = req.data;
              }else{
                this.lineClamp = 9;
              }
            })
        })
    },
    handleDetail () {
      var blockId = this.blockData.blockId;
      var contentId = this.contentId;
      var nodeId = this.nodeId;
      sessionStorage.setItem('floorDetailShow', this.floorDetailShow);
      sessionStorage.setItem('originName', JSON.stringify({ blockId: blockId, contentId: contentId, ind: 0 }));
      var appId = this.$appId;
      // const { href } = this.$router.resolve({ path: "odzid", query: { appId: appId, blockId: nodeId, contentId: contentId, floorflowId: this.blockData.id,dataType:2 } })
      // // this.open(href);
      // window.location.assign(href);
      if(this.contentWzUrl){
        this.open(this.contentWzUrl, "_blank");
        return;
      }
      this.routerJump('push','odzid',{ appId: appId, blockId: nodeId, contentId: contentId, floorflowId: this.blockData.id,dataType:2 },this.blockData.name);
    },
    isVideo (t) {
      var ty = false;
      if (t) {
        if (t.indexOf('.flv') > 0) {
          ty = true
        }
        if (t.indexOf('.mp4') > 0) {
          ty = true
        }
      }
      return ty;
    }
  }
}
</script>
<style>
/*m01_视频简介 开始*/
.video-info-box {
  display: flex;
}
.video-info-box .video-box .img {
  width: 100%;
  height: 100%;
  /* background-image: linear-gradient(30deg, #e1d5eb, #44b5ef); */
  background-color: #ededed;
  position: relative;
}
.video-info-box .video-box .img .onlyImg {
  width: initial;
  height: initial;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -50px 0 0 -40px;
}
.video-info-box .video-box,
.video-info-box .video-intro {
  height: 343px;
  width: 50%;
  flex: 1;
  padding: 20px;
}
.video-info-box .video-intro{
  overflow:auto;
}
.video-info-box .video-intro .origintext {
  height: auto;
  line-height: 30px;
  font-size: 14px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 9;
  text-align: justify;
  word-wrap: break-word;
}
.video-info-box .video-intro .text {
	position: relative;
	overflow: hidden;
	line-height: 30px;
  font-size: 14px;
  color: #333;
	text-align: justify;
	text-overflow: ellipsis;
	word-break: break-all;
  padding-right: 6px;
  }
.video-info-box .video-intro .text::before {
	float: right;
	height: 60px;
	content: '';
}
.video-info-box .video-intro .btn,.btns {
	position: relative;
	float: right;
	clear: both;
	margin-left: 10px;
	font-size: 14px;
	padding-left:25px;
	color: #0c78cf;
	line-height: 30px;
	border-radius: 4px;
	cursor: pointer;
	z-index: 10;
}
.video-info-box .video-intro .btn::before {
	position: absolute;
	left: 1px;
	color: #333;
	transform: translateX(-100%);
	content: '...';
}
/* .video-intro .tit {
  height: 48px;
  border-bottom: 1px dashed #ddd;
  font-size: 20px;
  line-height: 48px;
  color: #333;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-break: break-all;
}
.video-intro .text {
  height: auto;
  line-height: 30px;
  font-size: 14px;
  color: #333;
  padding-top: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  text-align: justify;
  word-wrap: break-word;
}*/
/* 针对ie浏览器做的多行文本省略号 */
/* .video-intro .text {
  word-break: break-all;
  position: relative;
}
.video-intro .text_after::after {
  content: "...";
  position: absolute;
  bottom: 0;
  right: 0;
  padding-left: 20px; 
  background: -webkit-linear-gradient(
    left,
    transparent,
    #fff 55%
  ); 
  background: -o-linear-gradient(right, transparent, #fff 55%);
  background: -moz-linear-gradient(right, transparent, #fff 55%);
  background: linear-gradient(to right, transparent, #fff 55%);
}
.video-intro .more-btn {
  height: 30px;
  width: 100px;
  background: #37a7ff;
  border-radius: 3px;
  position: absolute;
  bottom: 0px;
  right: 0px;
  text-align: center;
  color: #fff;
  line-height: 30px;
  cursor: pointer;
}
.video-intro .more-btn:hover {
  background: #2f8eed;
}
.video-intro .more-btn a {
  display: block;
  width: 100%;
  height: 100%;
  color: #ffffff;
}  */
/* 超小屏幕（手机，小于 768px） */
@media screen   and (max-width: 768px) {
  .video-intro .tit {
    font-size: 16px !important;
  }
  /* .video-intro .text {
    font-size: 12px !important;
  } */
  .video-introduction .video-info-box {
    display: block !important;
  }
  .video-introduction .video-info-box .video-box,
  .video-introduction .video-info-box .video-intro {
    width: calc(100% - 40px) !important;
    padding: 0 20px !important;
    height: auto !important;
  }
  .video-introduction .video-info-box .video-box .control[data-screen='normal'] video {
    height: 170px !important;
  }
}
/* 小屏幕（平板，大于等于 768px） */
/* @media (min-width: 768px) {

} */
</style>


// WEBPACK FOOTER //
// src/components/floorBlock/qyjjContent.vue